import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import { formatHot } from "@/utils/format";

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-primary-300 transition-colors"
      data-product-shop
    >
      <div className="relative w-full h-56 md:h-64 overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 国产久久久`}
          className="w-full h-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-foreground-950/70 text-accent-300 text-xs font-medium backdrop-blur">
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute bottom-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs">
          {movie.type === "movie" ? "电影" : "电视剧"}
        </span>
      </div>
      <div className="flex flex-col flex-1 p-3">
        <h3 className="font-heading text-base font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <div className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="w-1 h-1 rounded-full bg-background-400"></span>
          <span>{movie.region}</span>
          <span className="w-1 h-1 rounded-full bg-background-400"></span>
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-primary-400"></i>
            {formatHot(movie.hot)}
          </span>
        </div>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {movie.genres.slice(0, 3).map((genre) => (
            <span
              key={genre}
              className="px-1.5 py-0.5 rounded-md bg-secondary-100 text-secondary-800 text-[11px]"
            >
              {genre}
            </span>
          ))}
        </div>
        <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-2">
          {movie.summary}
        </p>
      </div>
    </Link>
  );
}